import {
    I18nProvider
} from "../i18n/I18nProvider.js";

import {
    AuthProvider
} from "../services/backend/AuthProvider.js";

import {
    BackendProvider
} from "../services/backend/BackendProvider.js";

import {
    ContentProvider
} from "../services/content/ContentProvider.js";

import {
    LearnerProfileProvider
} from "../services/backend/LearnerProfileProvider.js";

import {
    LearningRewardsProvider
} from "../services/backend/LearningRewardsProvider.js";

import {
    LessonProgressSyncProvider
} from "../services/backend/LessonProgressSyncProvider.js";

import {
    ShopProvider
} from "../services/backend/ShopProvider.js";
import {
    ReviewSignalsSyncProvider
} from "../services/backend/ReviewSignalsSyncProvider.js";
import {
    ExerciseTrackingProvider
} from "../services/backend/ExerciseTrackingProvider.js";

import {
    AppRouter
} from "./AppRouter.js";
import {
    DinoExperienceProvider
} from "../features/mascot/index.js";

/**
 * Root React application.
 *
 * Global application concerns belong here while individual routes and
 * educational features remain isolated below the router.
 */
function App() {
    return (
        <BackendProvider>
            <ContentProvider>
                <AuthProvider>
                    <ShopProvider>
                        <LessonProgressSyncProvider>
                            <ExerciseTrackingProvider>
                                <ReviewSignalsSyncProvider>
                                    <LearningRewardsProvider>
                                        <LearnerProfileProvider>
                                            <I18nProvider>
                                                <DinoExperienceProvider>
                                                    <AppRouter />
                                                </DinoExperienceProvider>
                                            </I18nProvider>
                                        </LearnerProfileProvider>
                                    </LearningRewardsProvider>
                                </ReviewSignalsSyncProvider>
                            </ExerciseTrackingProvider>
                        </LessonProgressSyncProvider>
                    </ShopProvider>
                </AuthProvider>
            </ContentProvider>
        </BackendProvider>
    );
}

export {
    App
};
